module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Especificações")])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [(Object.keys(_vm.variation.attributes).indexOf('color') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("color.label"),
      "columns": 3,
      "error": _vm.getError('attributes.color', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['color']),
      expression: "variation.attributes['color']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['color'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'color', $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('size') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("size.label"),
      "columns": 3,
      "error": _vm.getError('attributes.size', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['size']),
      expression: "variation.attributes['size']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['size'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'size', $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('crossDocking') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("crossDocking.label"),
      "columns": 3,
      "error": _vm.getError('attributes.crossDocking', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['crossDocking']),
      expression: "variation.attributes['crossDocking']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['crossDocking'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'crossDocking', $event.target.value)
      }
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-499be010","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/walmart/provide/Variation.vue
// module id = 3127
// module chunks = 0